import React from 'react';
import { useDispatch } from 'react-redux';
import { login } from 'state/modules/auth';
import { getLocalStorageItem } from 'utils/webStorage';
import { localStorageKeys } from 'utils/constants';
import Panel from 'components/Panel';
import LoginForm from 'components/Login/LoginForm';
import usePushForgotPassword from 'hooks/router/usePushForgotPassword';

const Login = () => {
  const dispatch = useDispatch();
  const pushForgotPassword = usePushForgotPassword();

  const handleForgotPassword = () => {
    pushForgotPassword();
  };

  const handleSubmit = ({ email, password }) => {
    const keepSession = getLocalStorageItem(localStorageKeys.keepSession) || false;
    const action = login(email, password, keepSession);
    dispatch(action);
  };

  return (
    <Panel outlined>
      <LoginForm
        onSubmit={handleSubmit}
        onForgotPassword={handleForgotPassword}
      />
    </Panel>
  );
};

export default Login;
